import React from 'react';
import { Box, Grid, Typography, Stack, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ArrowForward } from '@mui/icons-material';
import FlowChart from './FlowChart';
import imgUpload from '../assets/upload.png';
import Navbar from '../Auth/Navbar';

function FormDocuments() {
    
    return (
        <>
        <Navbar />
            <Stack sx={{ backgroundColor: '#eee', textAlign: 'center', minHeight: '90vh', borderRadius: '6px' }} alignItems={'center'} justifyContent={'center'}>
                <Stack sx={{ backgroundColor: '#FFF', minHeight: '80vh', borderRadius: '6px', width: { xs: '95%', sm: '85%' }, m: 4, p: 4 }}>
                    <Grid container justifyContent={'space-between'} spacing={2}>
                        <Grid item xs={12} sm={2}>
                            <FlowChart index={4} />
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Stack>
                                <Typography variant='h5' sx={{ fontWeight: 'bold', p: 1, textAlign: 'right', display: 'flex', flexDirection: 'row-reverse' }}>
                                    <span>-4</span>
                                    الوثائق والثبوتيات
                                </Typography>
                                <form>
                                    <Grid container spacing={2} justifyContent={'end'}>
                                        {[
                                            'وثائق الملكية (بحال توفرها)',
                                            'صور ووثائق توثق حالة العقار',
                                            'تقارير الضرر إن وجدت',
                                            'الموافقة الرسمية للترميم وإعادة الإعمار(إن وجدت)'
                                        ].map((label, index) => (
                                            <Grid item xs={12} sm={6} key={index}>
                                                <Box sx={{ width: '100%', textAlign: 'right', my: 1 }}>
                                                    <InputLabel>{label}</InputLabel>
                                                    <Box className='input' sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', mb: 3, p: 2, border: '1px dashed #aaa', borderRadius: '6px', cursor: 'pointer' }}>
                                                        <img src={imgUpload} alt='' width={'40px'} />
                                                        <FormHelperText>اضغط لاستعراض الملفات</FormHelperText>
                                                        <FormHelperText>الحجم الأعظمي المسموح به لكل ملف 5 ميجا بايت</FormHelperText>
                                                        <input type='file' style={{ display: 'none' }} />
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </form>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Stack direction={'row'} justifyContent={'end'} alignItems={'center'} sx={{ width: '100%', gap: 2, my: 4 }}>
                        <Link to={'/InputTerms'} className='btnLink'>
                            <ArrowBackIcon sx={{ mt: 1 }} />التالي
                        </Link>
                        <Link to='/InputInfoDesc' className='LinkbtnBack'>
                            رجوع
                            <ArrowForward sx={{ mt: 1 }} />
                        </Link>
                    </Stack>
                </Stack>
            </Stack>
        </>
    );
}

export default FormDocuments;
